<template>
  <transition
      appear
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
  >
    <q-layout id="signin">
      <div>
        <q-collapsible icon="fa-users" label="Войти через соцсеть" v-model="social" popup>
          <div class="layout-padding column items-stretch">
            <q-btn color="primary" icon="fab fa-google" label="google" @click="goSocial('google')"/>
            <q-btn color="primary" icon="fab fa-twitter" label="twitter"
                   @click="goSocial('twitter')"/>
            <q-btn color="primary" icon="fab fa-facebook" label="facebook"
                   @click="goSocial('facebook')"/>
            <q-btn color="primary" icon="fab fa-github" label="github" @click="goSocial('github')"/>
          </div>
        </q-collapsible>
        <q-collapsible icon="fa-at" label="Войти через email" v-model="mail" popup>
          <q-field
              label="Email"
              :error="$v.formIn.email.$error"
              :error-label="$v.formIn.email | errorLabel"
          >
            <q-input v-model="formIn.email" name="login" />
          </q-field>
          <q-field
              label="Пароль"
              :error="$v.formIn.password.$error"
              :error-label="$v.formIn.password | errorLabel"
          >
            <q-input type="password" v-model="formIn.password" name="password" />
          </q-field>
          <p>
            <small>Если пароль не введен вы получите письмо со ссылкой для входа</small>
          </p>
          <div class="row items-center justify-around">
            <!--<vue-recaptcha
                ref="recaptcha"
                @verify="onVerify"
                size="compact"
                sitekey="6Lc30iAUAAAAAPg7HB84ssePDk0wubvCMurbr_yC"
            />
            <q-btn color="primary" @click="sign" :disabled="formIn.verify === ''">
              Войти
            </q-btn>-->
            <g-recaptcha
                data-sitekey="6LcVV0wqAAAAAOJbPgv9TyrYZOH6cmw8diXQbjgS"
                :data-validate="validate"
                :data-callback="callback"
                data-btn-class="q-btn bg-primary text-white"
            >
              Войти
            </g-recaptcha>
          </div>
        </q-collapsible>
      </div>
      <q-toolbar slot="footer" class="toolbar">
        ©alexchetv, 2022
      </q-toolbar>
    </q-layout>
  </transition>
</template>
<style scoped lang="stylus">
  .q-field-bottom
    position absolute
    padding-top 0

  .q-btn
    margin 5px 0 !important

  #signin
    max-width 400px
    margin auto
    padding-top 10px

  footer
    .q-toolbar
      min-height 0
</style>

<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
// import VueRecaptcha from 'vue-recaptcha';
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';

export default {
  components: {
    // VueRecaptcha,
    gRecaptcha,
  },
  name: 'signIn',
  data() {
    return {
      social: true,
      formIn: {
        email: '',
        password: '',
        verify: '',
      },
    };
  },
  validations: {
    formIn: {
      email: {
        required: withParams({ message: 'Введите действительный email' }, required),
        email: withParams({ message: 'Введите действительный email' }, email),
      },
      password: {
        minLength: withParams({ message: 'Не менее 6 символов' }, minLength(6)),
        maxLength: withParams({ message: 'Не более 20 символов' }, maxLength(20)),
      },
    },
  },
  computed: {
    mail: {
      get() { return !this.social; },
      set(val) {
        this.social = !val;
      },
    },
  },
  mounted() {
    console.log('SIGNIN', this.$route.query);
    // console.log('siteUrl', process.env.siteUrl);
    document.title = 'Вход';
    if (this.$route.query.destroy === '1') {
      console.log('SIGNIN destroy!', this.$store);
      this.$store.dispatch('destroyDataDB')
        .then(() => {
          this.$router.replace({ query: {} }); // remove query
        });
    }
    if (this.$store.state.user.access_token) {
      const token = this.$store.state.user.access_token;
      this.$store.dispatch('waitRefresh')
        .then(() => { fetch('/logout', { headers: { authorization: token } }); });
    }
    this.$store.commit('modifyUser', null);
    this.$store.commit('setUnits', []);
    this.$store.commit('setParents', []);
    this.$store.commit('setRefreshing', false);
  },
  methods: {
    goSocial(provider) {
      window.location = `/auth/${provider}`;
    },
    validate() {
      this.$v.formIn.$touch();
      if (this.$v.formIn.$error) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      return true;
    },
    callback(token) {
      if (token) {
        const password = this.formIn.password.trim();
        if (password !== '') {
          this.$axios.post('/login', {
            email: this.formIn.email,
            password,
            'g-recaptcha-response': token,
          })
            .then((res) => {
              this.$router.push(`/enter/${res.data}`);
            })
            .catch((error) => {
              console.log('/login error', error);
              if (error.response && error.response.data) {
                this.$store.commit('pushError', error.response.data);
              } else {
                this.$store.commit('pushError', {
                  error: 'Ошибка',
                  message: 'Сервер не отвечает',
                });
              }
            });
        } else {
          this.$axios.post('/bymail', {
            email: this.formIn.email,
            'g-recaptcha-response': token,
          })
            .then(() => {
              // window.location = `${process.env.siteUrl}/tokensent?email=${this.formIn.email}`;
              this.$store.commit('pushError', {
                error: 'Проверьте почту',
                message: `Ссылка для входа отправлена на ${this.formIn.email}`,
                type: 'positive',
              });
              this.social = true;
            })
            .catch((error) => {
              console.log('/bymail error', error);
              if (error.response && error.response.data) {
                this.$store.commit('pushError', error.response.data);
              } else {
                this.$store.commit('pushError', {
                  error: 'Ошибка',
                  message: 'Сервер не отвечает',
                });
              }
            });
        }
      } else {
        console.log('Please check you are not robot');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/sign-in.vue